$(document).ready(function () {
    const CONFIRM_MESSAGE_DELETE_LOGO = "Vil du slette logo?";
    let ajaxPath = '/action/profile';
    let ajaxLockActive = false;

    let profileFormSelector = 'form#profile_form';

    const btnAddMvaHtml = '<button class="btn btn-primary" id="add_mva_button">Legg til MVA</button>';
    const btnDeleteMvaHtml = '<button class="btn btn-danger" id="delete_mva_button">Fjern MVA</button>';
    const btnAddForetaksregisteretHtml = '<button class="btn btn-primary" id="add_foretaksregisteret_button">Legg til Foretaksregisteret</button>';
    const btnDeleteForetaksregisteretHtml = '<button class="btn btn-danger" id="delete_foretaksregisteret_button">Fjern Foretaksregisteret</button>';

    $(document).on('click', profileFormSelector + ' #delete_logo_button', function () {
        // Check that an operation is not already in process
        if (ajaxLockActive) {
            return false;
        }

        if (!confirm(CONFIRM_MESSAGE_DELETE_LOGO)) {
            return;
        }

        ajaxLockActive = true;

        $.ajax({
            type: 'DELETE',
            url: ajaxPath + '/delete-logo',
            data: {},
            dataType: 'json'
        }).success(function () {
            // Remove image from DOM
            $(profileFormSelector + ' div#logo_image_wrapper').html('');
        }).error(function () {
            alert('Kunne ikke slette logo!');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    $(document).on('click', profileFormSelector + ' #add_mva_button', function () {
        if (ajaxLockActive) {
            return false;
        }

        ajaxLockActive = true;

        $.ajax({
            type: 'POST',
            url: ajaxPath + '/add-mva',
            dataType: 'json'
        }).success(function (data) {
            if(data.hasOwnProperty('orgnr')) {
                updateOrgnrFields(data.orgnr);
            }
            if(data.changed == true) {
                $(document).find('#mva_btn_wrapper').html(btnDeleteMvaHtml);
            }
        }).error(function () {
            alert('Kunne ikke legge MVA til organisasjonsnummer!');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    $(document).on('click', profileFormSelector + ' #delete_mva_button', function () {
        if (ajaxLockActive) {
            return false;
        }

        ajaxLockActive = true;

        $.ajax({
            type: 'POST',
            url: ajaxPath + '/delete-mva',
            dataType: 'json'
        }).success(function (data) {
            if(data.hasOwnProperty('orgnr')) {
                updateOrgnrFields(data.orgnr);
            }
            if(data.changed == true) {
                $(document).find('#mva_btn_wrapper').html(btnAddMvaHtml);
            }
        }).error(function (err) {
            alert('Kunne ikke fjerne MVA fra organisasjonsnummer!');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    $(document).on('click', profileFormSelector + ' #add_foretaksregisteret_button', function () {
        if (ajaxLockActive) {
            return false;
        }

        ajaxLockActive = true;

        $.ajax({
            type: 'POST',
            url: ajaxPath + '/add-foretaksregisteret',
            dataType: 'json'
        }).success(function (data) {
            if(data.hasOwnProperty('orgnr')) {
                updateOrgnrFields(data.orgnr);
            }
            if(data.changed == true) {
                $(document).find('#foretaksregisteret_btn_wrapper').html(btnDeleteForetaksregisteretHtml);
            }
        }).error(function (err) {
            alert('Kunne ikke legge Foretaksregisteret til organisasjonsnummer!');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    $(document).on('click', profileFormSelector + ' #delete_foretaksregisteret_button', function () {
        if (ajaxLockActive) {
            return false;
        }

        ajaxLockActive = true;

        $.ajax({
            type: 'POST',
            url: ajaxPath + '/delete-foretaksregisteret',
            dataType: 'json'
        }).success(function (data) {
            if(data.hasOwnProperty('orgnr')) {
                updateOrgnrFields(data.orgnr);
            }
            if(data.changed == true) {
                $(document).find('#foretaksregisteret_btn_wrapper').html(btnAddForetaksregisteretHtml);
            }
        }).error(function (err) {
            alert('Kunne ikke fjerne Foretaksregisteret fra organisasjonsnummer!');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    function updateOrgnrFields(orgnr) {
        $(document).find('#orgnr_input').val(orgnr);
        $(document).find('#orgnr_text').text(orgnr);
    }
});